export { ActivitiesTaskComponent } from './activities-task.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/activities/activities-task/index.ts